import * as React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Button from '@mui/material/Button';
import { IPalletBaseTypeFormValues, palletBaseTypeFormSchema } from '../../../../@types/model/masterData/palletBaseType/palletBaseTypeFormValues';
import { PillButton, ControlledTextField } from '@zz2/zz2-ui';
import { ControlledLabelledCheckBox } from '../../../../components/input/form/ControlledLabelledCheckBoxWrapper';
import CustomReactHookFormDevTools from '../../../../components/devtools/ReactHookFormDevTools';

interface IPalletBaseTypeFormProps {
    isLoading : boolean;
    initialValues : IPalletBaseTypeFormValues;
    onSubmit : (values : IPalletBaseTypeFormValues) => void;
    onClose : () => void;
}

const PalletBaseTypeForm = (props : IPalletBaseTypeFormProps) : React.ReactElement => {
    const schema = palletBaseTypeFormSchema;
    const { initialValues, onSubmit, onClose, isLoading } = props;

    const { handleSubmit, control, formState: { isValid, isDirty } } = useForm<IPalletBaseTypeFormValues>({
        defaultValues: initialValues,
        resolver: zodResolver(schema),
        mode: 'onChange',
    });

    return (
        <div>
            <CustomReactHookFormDevTools control={control} />
            <form onSubmit={handleSubmit(onSubmit)} className={'p20'}>
                <div className={'fdc aic'}>
                    <ControlledTextField
                        className={'mb10 w500'}
                        name={'code'}
                        label={'Code'}
                        control={control}
                        defaultValue={initialValues.code} />
                    <ControlledTextField
                        className={'mb10 w500'}
                        name={'name'}
                        label={'Name'}
                        control={control}
                        defaultValue={initialValues.name} />
                    <ControlledTextField
                        className={'mb10 w500'}
                        name={'defaultWeight'}
                        label={'Default Weight (KG)'}
                        type={'number'}
                        control={control}
                        defaultValue={initialValues.defaultWeight?.toString()}
                    />
                    <div className={'fdr jcfs mb5'}>
                        <ControlledLabelledCheckBox
                            className={'p0'}
                            name={'isActive'}
                            label={'Is Active'}
                            control={control}
                            defaultValue={initialValues.isActive} />
                    </div>
                    <div className={'fdr ml10 ais jcfe pt10 pb10'}>
                        <Button className={'cpd mr20'} type={'button'} onClick={onClose}>
                            CANCEL
                        </Button>
                        <PillButton
                            disabled={!isDirty || !isValid || isLoading}
                            className={'ml15 pl20 pr20 h35'}
                            text={'Save'}
                            type={'submit'}
                            color={'secondary'} />
                    </div>
                </div>
            </form>
        </div>
    );
};

export default PalletBaseTypeForm;
